import { Component, Input } from '@angular/core';

import { NgpProgress, NgpProgressIndicator } from 'ng-primitives/progress';

export type SuiProgressVariant = 'brand' | 'success' | 'warning' | 'danger';
export type SuiProgressSize = 'sm' | 'md';

/**
 * Determinate / indeterminate progress bar.
 *
 * Wraps the ng-primitives progress primitive, which owns the a11y contract
 * (`role="progressbar"` + `aria-valuenow/min/max/text`) and self-provides its
 * state on the `[ngpProgress]` element — so the `[ngpProgressIndicator]` fill,
 * a DOM descendant in this template, resolves that state through DI with no
 * `provideProgressState()` or `hostDirectives` needed on our side. The fill's
 * width is driven by the primitive (`[style.width.%]`); we style only colour,
 * height and the indeterminate animation.
 *
 * `value = null` → indeterminate (the primitive emits `data-indeterminate`).
 */
@Component({
  selector: 'sui-progress',
  standalone: true,
  imports: [NgpProgress, NgpProgressIndicator],
  templateUrl: './sui-progress.component.html',
  styleUrl: './sui-progress.component.scss',
})
export class SuiProgressComponent {
  /** Current value; `null` renders an indeterminate bar. Coerced by the primitive. */
  @Input() value: number | null = 0;

  @Input() min = 0;
  @Input() max = 100;

  /** Fill colour role. */
  @Input() variant: SuiProgressVariant = 'brand';

  /** Track height. */
  @Input() size: SuiProgressSize = 'md';
}
